export class IReportParameters {
    reportUrl: string;
    parameters: any;
    ActiveStatus: string;
    ReportName: string;
    ReportType: string;
    CatType: string;
    IsPdf: boolean;
}

export class IScheduleReportParameters {
    startDate: string;
    endDate: string;
    providerId: string[];
    locationId: string;
}